export default __webpack_public_path__ + "media/projects/purple2-6e08904c.svg";